module.exports = __webpack_public_path__ + "static/media/17.c71fc7e0.jpg";